// ─────────────────────────────────────────────────────────────────────────────
// optionsTab.ts (Training)
//
// Auto-advance toggle + exit-mode button. Sits next to the diagnostics
// "More" tab so the operator can flip behaviour without leaving the
// session.
// ─────────────────────────────────────────────────────────────────────────────

import { h } from "../../../ui/dom.js";
import { fireTraining, EventTypes } from "../fire.js";
import type { LiveState } from "../../../contract/liveState.js";

export function optionsTab(sessionId: string, state: LiveState): HTMLElement {
	const autoAdvance = state.training.autoAdvance === true;

	return h(
		"div",
		{ class: "space-y-3" },
		h(
			"section",
			{ class: "card space-y-3" },
			h("div", { class: "field-label" }, "Auto-advance"),
			h(
				"p",
				{ class: "text-xs text-slate-400" },
				"When a timer hits zero, automatically start the next one in the queue."
			),
			h(
				"div",
				{ class: "segmented", style: "grid-template-columns:repeat(2,minmax(0,1fr))" },
				h(
					"button",
					{
						type: "button",
						class: `seg ${autoAdvance ? "seg-on" : ""}`,
						onclick: () =>
							fireTraining(sessionId, EventTypes.TrainingSetAutoAdvance, "Auto-advance ON", {
								enabled: true,
							}),
					},
					"On"
				),
				h(
					"button",
					{
						type: "button",
						class: `seg ${!autoAdvance ? "seg-on" : ""}`,
						onclick: () =>
							fireTraining(sessionId, EventTypes.TrainingSetAutoAdvance, "Auto-advance OFF", {
								enabled: false,
							}),
					},
					"Off"
				)
			)
		),

		h(
			"section",
			{ class: "card space-y-2 border-accent-red/30" },
			h("div", { class: "field-label text-accent-red" }, "Exit training mode"),
			h(
				"p",
				{ class: "text-xs text-slate-300" },
				"Asks the desktop to leave training mode and return to the AFL control panel."
			),
			h(
				"button",
				{
					type: "button",
					class: "btn-danger w-full",
					onclick: () => {
						if (!confirm("Exit training mode on the desktop?")) return;
						void fireTraining(sessionId, EventTypes.TrainingExit, "Exit requested");
					},
				},
				"Exit training mode"
			)
		)
	);
}
